import React from "react";

import QuestionDetailRating from "./Rating";
import QuestionDetailChoices from "./Choices";

const QuestionDetail = ({ question, surveys, handleState })=>{
    
    if (question.type === "rating"){
        return (
            <React.Fragment>
                <QuestionDetailRating question={question} surveys={surveys}/>
            </React.Fragment>
        )
    }

    if (question.type === "multiple-choice" || question.type === "like") {
        return (
            <React.Fragment>
                <QuestionDetailChoices question={question} surveys={surveys} />
            </React.Fragment>
        )
    }

    return null;
}

export default QuestionDetail;